export enum ILengthUnit {
    undefined = 0,
    feet = 1,
    meters = 2,
    centimeters = 3
}
